const ROUND_TO_INT = 1e3;
export { ROUND_TO_INT };

//# sourceMappingURL=index117.js.map